import { numberFormat, NUMBER_STYLES } from '@fiverr-private/localization';

export const formatPercentage = (value) => numberFormat(value / 100, {
    fallbackValue: `${value}%`,
    style: NUMBER_STYLES.PERCENT
});
